import React from 'react';

function FilterIcon({ ...props }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            {...props}
        >
            <path
                d="M13.8825 4.27495H15.3M2.70001 4.27495H10.575M13.8825 13.8825H15.3M13.8825 13.8825C13.8825 14.67 13.2525 15.3 12.465 15.3C11.7563 15.3 11.1263 14.67 11.0475 13.8825C11.0475 13.095 11.6775 12.465 12.465 12.465C13.2525 12.465 13.8825 13.095 13.8825 13.8825ZM2.70001 13.725H10.575M7.03126 8.99995H15.3M2.70001 8.99995H4.11751M4.11751 8.99995C4.11751 8.21245 4.74751 7.58245 5.53501 7.58245C6.32251 7.58245 6.95251 8.21245 6.95251 8.99995C6.95251 9.78745 6.32251 10.4175 5.53501 10.4175C4.74751 10.4175 4.11751 9.78745 4.11751 8.99995ZM12.465 5.53495C13.2525 5.53495 13.8825 4.90495 13.8825 4.11745C13.8825 3.32995 13.2525 2.69995 12.465 2.69995C11.6775 2.69995 11.0475 3.32995 11.0475 4.11745C11.0475 4.90495 11.7563 5.53495 12.465 5.53495Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default FilterIcon;
